/**
 * Maps a worklist search box (field + value) to the sample search API parameter.
 *
 * The search SPs AND their identifier filters together, so "All Identifiers" must pick
 * ONE parameter. It is inferred from the identifier formats used by this LIS:
 *   UHID      {CentreCode}.{digits}            e.g. MHL01.0000000052
 *   Lab No    {letters}{centre digits}{yyMMdd}{seq} → letters + 10+ digits, e.g. MHL012610010004
 *   Barcode   digits only, letters + <10 digits, or dash-separated, e.g. 10001107, AUR00012456, BC-APP-908393
 *   Name      anything with a space or letters only, e.g. "QA LINEAGE", "SHARMA"
 * Anything else falls back to Lab No (the previous behaviour).
 */
const FIELD_PARAM = {
  UHID: 'uhid',
  LABNO: 'ledgerTransactionNo',
  PATIENT: 'patientName',
  BARCODE: 'barcodeNo',
  SAMPLENO: 'sampleNo',
  INVESTIGATION: 'investigationName',
};

export const detectIdentifierParam = (value) => {
  const v = value.trim();
  if (/^[A-Z0-9]+\.\d+$/i.test(v)) return 'uhid';
  if (/^[A-Z]{2,}\d{10,}$/i.test(v)) return 'ledgerTransactionNo';
  if (/^\d{4,}$/.test(v) || /^[A-Z]{2,}\d{4,9}$/i.test(v) || /^[A-Z0-9]+(-[A-Z0-9]+)+$/i.test(v)) return 'barcodeNo';
  if (/\s/.test(v) || /^[A-Z]+$/i.test(v)) return 'patientName';
  return 'ledgerTransactionNo';
};

export const buildSampleSearchParam = (field, value) => {
  const trimmed = (value || '').trim();
  if (!trimmed) return {};
  const param = FIELD_PARAM[field] || detectIdentifierParam(trimmed);
  return { [param]: trimmed };
};
